import styled from 'styled-components';

const CartierLogoText = styled.span`
  font-family: ${({ theme }) => theme.typography.fonts.cartierLogos};
`;

export default CartierLogoText;
